import React from "react";
import { UnifiedPopup, PopupContent, getPopupGradient } from "../UnifiedPopup";

interface IProps {
  handleClosePopup: () => void;
  isPopupShowing: boolean;
  currentTrack?: string;
}

const AttractionGapWarningPopup: React.FC<IProps> = ({ handleClosePopup, isPopupShowing, currentTrack }) => {
  const gradientStyle = getPopupGradient(currentTrack);

  return (
    <UnifiedPopup isOpen={isPopupShowing} onClose={handleClosePopup} track={currentTrack} maxWidth="998px">
      <PopupContent
        title="Session Gap Recommendation"
        message={
          <p className={currentTrack === "BATTLE_KART_TRACK" ? "add-source-sans-pro-font" : ""}>
            If you are booking BattleKart and Hyper Karting, we recommend booking sessions with a 40 minute gap between each attraction{" "}
            <span className={currentTrack === "BATTLE_KART_TRACK" ? "add-source-sans-pro-font" : ""}>(which allows for delays).</span>
          </p>
        }
        buttonText="Close"
        onButtonClick={handleClosePopup}
        gradientStyle={gradientStyle}
      />
    </UnifiedPopup>
  );
};

export default AttractionGapWarningPopup;
